<template>
  <div>
    <v-btn :loading="loading" :disabled="loading" outline color="grey" @click="getShopProfile">
      <v-icon>fa fa-print</v-icon>
      &nbsp{{ $t('Print Covers') }}
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import dayjs from 'dayjs'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import numeral from 'numeral'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}

export default {
  props: ['orders'],
  data() {
    return {
      profile: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    getShopProfile: function() {
      let vm = this
      vm.loading = true
      if (!vm.selectedBot.pageid || vm.selectedBot.pageid == null) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid
      }
      let auth = null
      api.getShopProfile(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        // console.log(response)
        if (response.shopprofile) {
          vm.profile = response.shopprofile
          vm.printPDF()
        }
      })
    },

    printPDF() {
      var vm = this

      var data = this.orders.map((el, i) => {
        var productdetail
        var payment = vm.$t('Credit card')
        if (el.payment == 'banktransfer' || el.payment == 'transfer') {
          payment = vm.$t('Bank Transfer')
        } else if (el.payment == 'qrcode') {
          payment = 'Qr Code'
        } else if (el.payment == 'fbpay') {
          payment = vm.$t('Mobile Banking')
        } else if (el.payment == 'cod') {
          payment = vm.$t('cod_charge')
        }
        try {
          productdetail = JSON.parse(el.productdetail)
        } catch (error) {
          productdetail = []
        }

        var qrimage = {}
        if (el.note && el.note.includes('base64,')) {
          qrimage = {
            image: el.note,
            width: 80,
            alignment: 'right'
          }
        } else {
          qrimage = {
            text: '',
            width: 80
          }
        }
        return [
          {
            columns: [
              {
                width: 225,
                table: {
                  widths: [200],
                  heights: [120],
                  body: [
                    [
                      {
                        text: [
                          { text: vm.$t('Sender') + '\n', style: 'header' },
                          { text: vm.profile.pageaddress, style: 'paragraph' }
                        ],
                        style: 'container'
                      }
                    ]
                  ]
                }
              },
              {
                width: 225,
                table: {
                  widths: [285],
                  heights: [120],
                  body: [
                    [
                      {
                        text: [
                          { text: vm.$t('Receiver') + '\n', style: 'header' },
                          { text: el.nameaddress, style: 'paragraph' }
                        ],
                        style: 'container'
                      }
                    ]
                  ]
                }
              }
            ]
          },
          {
            table: {
              widths: ['*'],
              body: [[' '], [' ']]
            },
            margin: [0, 15, 0, 15],
            layout: {
              hLineWidth: function(i, node) {
                return i === 0 || i === node.table.body.length ? 0 : 0.1
              },
              vLineWidth: function(i, node) {
                return 0
              },
              hLineColor: function(i, node) {
                return i === 0 || i === node.table.body.length ? '' : '#bcbcbc'
              }
            }
          },
          {
            margin: [0, 0, 0, 8],
            columns: [
              {
                width: '*',
                stack: [
                  {
                    text: vm.$t('Receipt'),
                    style: 'receipt'
                  },
                  {
                    table: {
                      widths: [200, 150],
                      body: [
                        [
                          vm.$t('Order Date'),
                          {
                            text: dayjs(el.timestamp).format('DD/MM/YYYY'),
                            style: { alignment: 'right' }
                          }
                        ],
                        [vm.$t('Order No.'), { text: el.id, style: { alignment: 'right' } }],
                        [
                          vm.$t('Shipping option'),
                          { text: vm.$t(el.shippingtype), style: { alignment: 'right' } }
                        ],
                        [
                          vm.$t('Payment Method'),
                          {
                            text: payment + ' - ' + vm.$t(el.transactionid),
                            style: { alignment: 'right' }
                          }
                        ]
                      ]
                    },
                    layout: {
                      hLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineWidth: function(i, node) {
                        return 0
                      },
                      hLineWidth: function(i, node) {
                        return 0
                      }
                    }
                  },
                  {
                    text: vm.$t('Product Detail'),
                    margin: [0, 15, 0, 10],
                    style: {
                      bold: true,
                      fontSize: 14
                    }
                  },
                  {
                    table: {
                      widths: [250, 100],
                      body: !el.productlist.length
                        ? [{ text: el.productdetail }]
                        : el.productlist.map((val, i) => {
                            var product = val.name + ` x ${val.quantity} (${val.option})`
                            if (val.subproduct) {
                              product += '\n'
                              val.subproduct.map(sub => {
                                product +=
                                  ' - ' +
                                  sub.name +
                                  ' x ' +
                                  sub.quantity +
                                  ` SKU:${sub.sku ? sub.sku : '- '}` +
                                  (sub.option ? ' (' + sub.option + ')' : '') +
                                  '\n'
                              })
                            }
                            return [
                              product,
                              {
                                text:
                                  '฿' +
                                  numeral(parseFloat(val.price) * parseInt(val.quantity)).format(
                                    '0,0.00'
                                  ),
                                style: { alignment: 'right' }
                              }
                            ]
                          })
                    },
                    layout: {
                      hLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      }
                    }
                  }
                ]
              },
              {
                ...qrimage
              }
            ]
          },
          {
            pageBreak: i + 1 == this.orders.length ? '' : 'after',
            margin: [0, 20, 0, 0],
            table: {
              widths: [200, 150],
              body: [
                [
                  vm.$t('Subtotal') + ':',
                  {
                    text:
                      '฿' +
                      numeral(parseFloat(el.total) - parseFloat(el.shippingcharge)).format(
                        '0,0.00'
                      ),
                    style: { alignment: 'right' }
                  }
                ],
                [
                  vm.$t('Discount') + ':',
                  { text: '฿' + el.discount, style: { alignment: 'right' } }
                ],
                [
                  vm.$t('Shipping fee') + ':',
                  { text: '฿' + el.shippingcharge, style: { alignment: 'right' } }
                ],
                [vm.$t('Total') + ':', { text: '฿' + el.amount, style: { alignment: 'right' } }]
              ]
            },
            layout: {
              vLineWidth: function(i, node) {
                return 0
              },
              hLineWidth: function(i, node) {
                return 0
              }
            }
          }
        ]
      })

      var dd = {
        content: [data],
        styles: {
          header: {
            fontSize: 20,
            color: '#ff5656',
            bold: true
          },
          paragraph: {
            fontWeight: 200
          },
          container: {
            margin: [10, 10, 10, 10]
          },
          receipt: {
            fontSize: 18,
            color: '#ff5656',
            bold: true
          }
        },
        defaultStyle: {
          font: 'THSarabunNew'
        }
      }
      vm.loading = false
      pdfMake.createPdf(dd).open()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintAllCoversBearhouse.vue